export default __webpack_public_path__ + "static/media/step8-4.48227c0c.png";